<template>
<button :class="className" :id="id" :type="type">{{text}}</button>
</template>

<script>
export default {
  props: {
    className: String,
    type: String,
    text: String
  }
}
</script>

<style lang="scss" scoped>
.c-btn {
  margin: 0 auto;
  font-weight: 700;
  border-radius: 50px;
  box-shadow: $bs_default;
  box-sizing: border-box;
  display: block;
  transition-duration: .3s;

  @include media-queries-sp {
    &:not(:first-child){
      margin-top: 30px
    }
  }
  &__border {
    @extend .c-btn;
    color: $color_blue;
    border: solid 3px $color_blue;
    background: #fff;

    &:hover {
      color: $color_blue_dark;
      border: solid 3px $color_blue_dark;
      box-shadow: $bs_learge;
    }
    &--l{
      @extend .c-btn__border;
      max-width: 300px;
      width: 300/1000*100vw;
      min-width: 250px;
      height: 60px;
      font-size: 1.8rem;
    }
  }
  &__primary {
    @extend .c-btn;
    color: #fff;
    background: $color_blue;
    &:hover {
      background: $color_blue_dark;
      box-shadow: $bs_learge;
    }
    &--l{
      @extend .c-btn__primary;
      max-width: 300px;
      width: 300/1000*100vw;
      min-width: 250px;
      height: 60px;
      font-size: 1.8rem;

      &-popup {
        @extend .c-btn__primary--l;
        position: relative;

        &.--disabled {
          box-shadow: none;
          opacity: 0.3;
          &::after{
            display: none;
          }
        }
        &::after{
          content: '';
          width: 1.6rem;
          height: 1.6rem;
          background: url('/assets/img/ic_popup.png');
          background-size: 100% 100%;
          transition-duration: .3s;
          position: absolute;
          right: 15%;
          opacity: 0;
        }
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      }

      &-download {
        @extend .c-btn__primary--l;
        position: relative;
        &::after{
          content: '';
          width: 1.6rem;
          height: 1.6rem;
          background: url('/assets/img/ic_download.png');
          background-size: 100% 100%;
          transition-duration: .3s;
          position: absolute;
          right: 15%;
          opacity: 0;
        }
        &:hover {
          &::after {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
